import { type ICombinedState } from '../reducers';

export const sidebarVisibleSelector = (state: ICombinedState) => state.header.sidebarVisible;

export const mobileVisibleSelectSidebar = (state: ICombinedState) => state.header.sidebarVisibleMobile;

export const visibleChat = (state: ICombinedState) => state.header.visibleChat;
